import Base from './base'
import {
  CrmReferenceObjectsResponse,
  DealCrmFieldsResponse,
  UpdateDealCrmFieldsPayload,
} from '../types/opportunityFields'

export const REFERENCE_SEARCH_LIMIT = 10

export default class OpportunityFields extends Base {
  getDealCrmFields(crmId: string): Promise<DealCrmFieldsResponse | null> {
    return this.api.get(`deal_crm_fields/${crmId}`)
  }

  updateDealCrmFields(crmId: string, payload: UpdateDealCrmFieldsPayload): Promise<void> {
    return this.api.put(`deal_crm_fields/${crmId}`, payload)
  }

  searchReferenceObjects(
    term: string,
    crmObjectTypes: string[]
  ): Promise<CrmReferenceObjectsResponse | null> {
    const params = new URLSearchParams()
    params.append('q', term)
    crmObjectTypes.forEach(type => params.append('crm_object_types', type))
    params.append('limit', String(REFERENCE_SEARCH_LIMIT))

    return this.api.get(`search_reference_objects?${params.toString()}`)
  }
}
